import ChangePassword from '@components/my-account/change-password';
import { useRouteLang } from 'src/hooks/use-route-lang';

export default function ChangePasswordPage() {
  const lang = useRouteLang();

  return <ChangePassword lang={lang} />;
}
